"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('es6-promise').polyfill();
require('es6-object-assign').polyfill();
require('array.prototype.find').shim();
require('array.prototype.findindex').shim();
var DependencyLoader_1 = require("../DependencyLoader");
var RenderEngine_1 = require("../RenderEngine");
var MockService_1 = require("../MockService");
var Logger_1 = require("../Logger");
var Routing_1 = require("../Routing");
var Service_1 = require("../Utilities/Service");
var Utilities_1 = require("../Utilities");
var Config_1 = require("../Config");
var loader = new DependencyLoader_1.DependencyLoader();
var engine = new RenderEngine_1.RenderEngine();
var mockService = new MockService_1.MockService();
var logger = new Logger_1.Logger();
var routing = new Routing_1.Routing();
var service = new Service_1.ServiceEndpointHandler();
var PageLifeCycleStep;
(function (PageLifeCycleStep) {
    PageLifeCycleStep[PageLifeCycleStep["Initialization"] = 0] = "Initialization";
    PageLifeCycleStep[PageLifeCycleStep["Ready"] = 1] = "Ready";
})(PageLifeCycleStep = exports.PageLifeCycleStep || (exports.PageLifeCycleStep = {}));
if (typeof console == 'undefined' || typeof console.log == 'undefined')
    console = { log: function (message) { alert(message); } };
var Player = (function () {
    function Player() {
    }
    Player.prototype.initialize = function (context) {
        exports.csod.lifecycle = PageLifeCycleStep.Initialization;
        exports.csod.context = context;
        exports.csod.context.serviceUrls = Config_1.config.serviceUrls;
        exports.csod.context.cultureName = exports.csod.context.cultureName
            || (navigator.language || navigator['userLanguage']);
        var queryObj = exports.csod.utils.parseQuery();
        if (queryObj.log) {
            exports.csod.context.log.level = queryObj.log;
        }
        if (queryObj.debug) {
            exports.csod.context.debug = queryObj.debug === 'true';
        }
        if (queryObj.rtl) {
            document.documentElement.setAttribute('dir', 'rtl');
        }
        exports.csod.context.previewMode = exports.csod.context.debug && exports.csod.context.env === 'development' && exports.csod.context.token === 'devToken';
        if (exports.csod.context.env === 'development') {
            exports.csod.utils.setDefaultAmplitudeAPIKey();
        }
        loader.setContext(exports.csod.context);
        logger.initialize(context.page, context.serviceBase + context.serviceUrls.logging + 'log', context.correlation, context.log);
        if (typeof exports.csod.context.endpoints !== 'undefined') {
            service.initialize(exports.csod.context.endpoints.api, exports.csod.context.endpoints.cloud);
        }
        if (typeof extendSession !== 'undefined') {
            var lastInterval_1 = new Date();
            setInterval(function () {
                if (exports.csod.lastEventDate > lastInterval_1) {
                    extendSession(function () {
                        exports.csod.utils.renewToken();
                    });
                }
                lastInterval_1 = new Date();
            }, 300000);
        }
        return Promise.all([
            loader.injectPageControls(),
            generateAllLocales()
        ])
            .then(function () { return mockService.initialize(context, loader); })
            .then(function () { return Promise.all([
            wrapRenderInPromise(),
            routing.initialize(exports.csod.pageDefinition.routes),
            exports.csod.pageDefinition.initialize(queryObj)
        ]); })
            .then(function () {
            exports.csod.engine.commit();
            exports.csod.lifecycle = PageLifeCycleStep.Ready;
        })
            .catch(function (error) { return console.warn(error); });
    };
    return Player;
}());
exports.Player = Player;
function wrapRenderInPromise() {
    return new Promise(function (resolve) {
        engine.render(document.getElementById('cs-root'));
        Utilities_1.triggerEvent("player-init-render");
        resolve();
    });
}
function setLocalesCulture(culture) {
    var groups = exports.csod.locales._groups;
    if (groups) {
        return fetchLocalizationValuesNoFail(groups.join(','), culture);
    }
    else {
        exports.csod.logger.warn('Current locales group list is empty or missing');
        return Promise.reject('Missing Groups');
    }
}
function generateAllLocales() {
    var allLocales = window['__LOCALES__'] || {};
    if (exports.csod.pageDefinition.hasOwnProperty('locales') && exports.csod.pageDefinition.locales.length > 0)
        allLocales[exports.csod.context.page] = exports.csod.pageDefinition.locales;
    var groupList = createLocalesList(allLocales);
    return fetchLocalizationValuesNoFail(groupList);
}
function createLocalesList(locales) {
    var localesList = [];
    Object.keys(locales).forEach(function (item) {
        if (locales[item]) {
            for (var i = 0; i < locales[item].length; i++) {
                var group = locales[item][i];
                if (localesList.indexOf(group) < 0) {
                    localesList.push(group);
                }
            }
        }
    });
    exports.csod.locales._groups = localesList;
    if (localesList.length > 0) {
        return localesList.join(',');
    }
    return '';
}
function fetchLocalizationValuesNoFail(groupList, culture) {
    return new Promise(function (resolve) {
        if (exports.csod.context.hasOwnProperty('corp') && exports.csod.context.hasOwnProperty('cultureName') && groupList.length > 0) {
            var errMsg_1 = "Localization service failed with this group list: " + groupList;
            exports.csod.locales.mode = "basePage";
            exports.csod.service.get(exports.csod.context.serviceBase + exports.csod.context.serviceUrls.localization
                + 'localizations/ui?groups='
                + groupList
                + '&culture='
                + (exports.csod.pageDefinition.setCulture
                    ? exports.csod.pageDefinition.setCulture(exports.csod.context.cultureName)
                    : (culture || exports.csod.context.cultureName))
                + '&version='
                + exports.csod.context.localizationVersion)
                .then(function (locales) {
                Object.keys(locales.data || {}).forEach(function (key) {
                    locales.data[key.toLowerCase().trim()] = locales.data[key];
                });
                exports.csod.locales._all = locales.data;
                resolve();
            })
                .catch(function (err) {
                console.warn(errMsg_1);
                resolve(errMsg_1);
            });
        }
        else {
            resolve('developing in preview mode.');
        }
    });
}
var player = new Player();
exports.csod = {
    _services: {},
    tracking: {},
    locales: {
        mode: 'preview',
        _groups: [],
        _all: {},
        get: function (key, fallback) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            var translated = fallback || key;
            var ceslocal = /ceslocal=1/g;
            if (ceslocal.test(window.location.search)) {
                translated = translated + " [" + key + "]";
            }
            if (window.location.hostname === 'localhost') {
                translated = "*" + translated + "*";
            }
            if (this.mode === 'basePage') {
                if (this._all[key]) {
                    translated = this._all[key];
                }
                else if (this._all[key.toLowerCase().trim()]) {
                    translated = this._all[key.toLowerCase().trim()];
                }
                else {
                    console.warn("Key: \"" + key + "\" is not in the locales current group(s). Please link it to the group to get the translation.");
                }
            }
            if (arguments.length > 2) {
                for (var i = 2; i < arguments.length; i++) {
                    translated = translated.replace(new RegExp("\\{" + (i - 2) + "\\}", 'g'), arguments[i]);
                }
            }
            return translated;
        },
        setLocalesCulture: setLocalesCulture
    },
    pages: {},
    context: {
        playerBase: '',
        home: '',
        serviceBase: '',
        basePath: '',
        trackerSettings: {
            vendorAPIKeys: {
                amplitude: ''
            }
        }
    },
    lifecycle: PageLifeCycleStep.Initialization,
    lastEventDate: new Date(),
    mockService: mockService,
    engine: engine,
    player: player,
    loader: loader,
    logger: logger,
    routing: routing,
    service: service,
    notify: {},
    viewModel: {},
    pageDefinition: {
        mocks: {
            enabled: false,
            services: [],
            timeOut: 5
        },
        locales: [],
        routes: null,
        initialize: function () { return new Promise(function (resolve, reject) { reject('page initialize method not loaded.'); }); },
        events: {}
    },
    utils: {
        parseQuery: function () {
            var query_string = {};
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (typeof query_string[pair[0]] === 'undefined') {
                    query_string[pair[0]] = decodeURIComponent(pair[1]);
                }
            }
            return query_string;
        },
        renewToken: function () {
            return exports.csod.service.api.post('services/x/session/v1/session/refresh')
                .then(function (response) {
                exports.csod.context.token = response.data;
            });
        },
        focusElementByTag: function (isOpen, focusTag) {
            var element = document.querySelectorAll("[data-tag=\"" + focusTag + "\"]");
            if (isOpen && element.length)
                element[0]['focus']();
            return !isOpen;
        },
        createUUID: function () {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            var uuid = s.join("");
            return uuid;
        },
        track: function (moniker, eventName, callback) {
            window.addEventListener("player-" + moniker + "-" + eventName, callback);
        },
        triggerInitRender: function (wait) {
            if (wait === void 0) { wait = 10; }
            setTimeout(function () { return Utilities_1.triggerEvent('player-init-render'); }, wait);
        },
        loadScript: Utilities_1.appendScript,
        convertBytesToFileSize: Utilities_1.convertBytesToFileSize,
        createLogger: function (name, level, batchsize) {
            var logger = new Logger_1.Logger();
            logger.initialize(name, exports.csod.context.serviceBase + exports.csod.context.serviceUrls.logging + 'log', exports.csod.context.correlation, { batchsize: batchsize.toString(), level: level });
            return logger;
        },
        setDefaultAmplitudeAPIKey: function () {
            if (!exports.csod.context.trackerSettings.vendorAPIKeys.amplitude) {
                exports.csod.context.trackerSettings.vendorAPIKeys.amplitude = 'f94585af7117c2f8286a4d71a167764e';
            }
        }
    },
    error: {
        display: function () {
            var secure = window.location.protocol == 'http:' ? '' : 'secure;';
            window.document.cookie = "CyberUErrorMessage=" + exports.csod.context.correlation + ";path=/;" + secure;
            var applicationBase = exports.csod.context.applicationBase || exports.csod.context.serviceBase;
            var path = window.location.pathname.substring(applicationBase.length);
            if (exports.csod.context.debug)
                console.log('An error occured.');
            else
                window.location.replace(applicationBase + "error.aspx?aspxerrorpath=/" + path);
        }
    }
};
window['csod'] = exports.csod;



//////////////////
// WEBPACK FOOTER
// ./src/PageLayer/Player.ts
// module id = 27
// module chunks = 0